import { Button, Modal } from 'gatorcomponents';
import React from 'react';
import useLocale from '@/hooks/useLocale';
import AckedSnappy from '@/media/gatorProtect/acknowledge_snappy.png';
import { differenceInDays } from 'date-fns';
import * as Styles from './GatorProtectAcknowledge.styles';


const GatorProtectAcknowledgedModal = ({
  handleClose,
  selectedPlan,
  handleRedirect,
}) => {
  const days = differenceInDays(new Date(selectedPlan?.expire_date), new Date());
  const { gatorProtect: gatorProtectLocale } = useLocale();

  const getAreDaysExpired = (selectedPlan) => {
    if (!selectedPlan) {
      return false;
    }

    if (selectedPlan.expire_days != null) {
      return Number.isInteger(selectedPlan.expire_days) && selectedPlan.expire_days <= 0;
    }
    return false;
  };

  const getSelectedPlanInfo = (selectedPlan) => {
    const areDaysExpired = getAreDaysExpired(selectedPlan);
    const isTrialActive = selectedPlan ? selectedPlan.is_trial && !areDaysExpired : false;
    const planName = selectedPlan?.shared_hosting_plan;

    return {
      isTrialActive,
      planName,
    };
  };

  const {
    isTrialActive, planName,
  } = getSelectedPlanInfo(selectedPlan);

  const localeTrialProPath = isTrialActive ? 'trial' : 'pro';

  return (
    <Modal onClose={handleClose} maxHeight={750} data-testid="gator-protect-acknowledged-modal">
      <Styles.ModalContainer>
        <Styles.Title>
          {gatorProtectLocale.acknowledgedModal.title[localeTrialProPath]({ days, plan: planName })}
        </Styles.Title>

        <Styles.Image src={AckedSnappy} />

        <Styles.SecondTitle>
          {isTrialActive
            ? gatorProtectLocale.acknowledgedModal.secondTitle.trial({ days })
            : gatorProtectLocale.acknowledgedModal.secondTitle.pro
          }
        </Styles.SecondTitle>

        <Styles.Description>
          {gatorProtectLocale.acknowledgedModal.description[localeTrialProPath]}
        </Styles.Description>

        <Styles.PerksTitle>
          {gatorProtectLocale.acknowledgedModal.perksTitle}
        </Styles.PerksTitle>

        <Styles.PerksCard>
          <Styles.PerksList>
            {gatorProtectLocale.acknowledgedModal.perks.map(perk => (
              <Styles.PerkItem key={perk}>{perk}</Styles.PerkItem>
            ))}
          </Styles.PerksList>
        </Styles.PerksCard>

        <Styles.ActionsRow>
          <Button
            onClick={handleRedirect}
            label={gatorProtectLocale.acknowledgedModal.cta[localeTrialProPath]}
            size="large"
          />
        </Styles.ActionsRow>

        <Styles.AdditionalInfo>
          {gatorProtectLocale.acknowledgedModal.additionalInfo[localeTrialProPath]}
        </Styles.AdditionalInfo>
      </Styles.ModalContainer>
    </Modal>
  );
};

export default GatorProtectAcknowledgedModal;
